import { ButtonProps } from '@ui/buttons/Button/types'
import { PressableIconProps } from '@ui/buttons/PressableIcon/types'
import { RemoteConfigState } from '@ca/common'
import { colors } from '@ui/colors'
import { StatusVariant } from '@ui/elements/Status/types'

export type AppVersionStatus = 'behind' | 'synched' | 'ahead' | 'unknown'
export type CmsVersionStatus = RemoteConfigState | 'manual' | 'unknown'
export type AllVersionStatus = 'neutral' | 'warning' | 'danger'

export type AppVersionProps = {
  title?: string
  status?: {
    text: string
    variant: StatusVariant
  }
  rows: {
    label?: string
    value: React.ReactNode
  }[]
  button?: ButtonProps
  action?: PressableIconProps
  actionClose?: boolean
  loading?: boolean
}

export const appStatusVariant: Record<AppVersionStatus, StatusVariant> = {
  behind: 'danger',
  synched: 'success',
  ahead: 'active',
  unknown: 'neutral',
}

export const cmsStatusVariant: Record<CmsVersionStatus, StatusVariant> = {
  public: 'success',
  preview: 'warning',
  manual: 'danger',
  unknown: 'neutral',
}

export const colorText: Record<AllVersionStatus, string> = {
  neutral: colors.black25,
  warning: colors.amber[500],
  danger: colors.red[600],
}

export const colorBack: Record<AllVersionStatus, string> = {
  neutral: colors.white50,
  warning: colors.amber[50],
  danger: colors.red10,
}
